import cx from 'classnames'
import * as React from 'react'

import BaseModal from '../../components/BaseModal/BaseModal'
import CalculatorDkkAmountComp from '../../components/CalculatorDkkAmountComp/CalculatorDkkAmountComp'
import InfoBox from '../../components/InfoBox/InfoBox'
import Rte from '../../components/Rte/Rte'
import type { CalculatorDkkAmountDataViewModel } from '../../view-models/CalculatorDkkAmountDataViewModel'
import type { TitleAndTextViewModel } from '../../view-models/TitleAndTextViewModel'
import styles from './calculator-dkk-amount-style.css'

type Props = {
  title?: string
  calculatorData: CalculatorDkkAmountDataViewModel
}
type State = {
  isModalOpen: boolean
  activeHelpText: TitleAndTextViewModel
}

class CalculatorDkkAmount extends React.Component<Props, State> {
  static displayName = 'CalculatorDkkAmount'
  static defaultProps = {}
  state = {
    isModalOpen: false,
    activeHelpText: {
      text: '',
      title: '',
    },
  }

  handleOpenModal = (rowHelpText: TitleAndTextViewModel) => {
    this.setState({
      isModalOpen: true,
      activeHelpText: rowHelpText,
    })
  }
  handleCloseModal = () => {
    this.setState({
      isModalOpen: false,
      activeHelpText: {
        text: '',
        title: '',
      },
    })
  }

  render() {
    const { title, calculatorData } = this.props
    const { isModalOpen, activeHelpText } = this.state

    return (
      <div className={styles.calculator}>
        <Rte source={title} />
        {<CalculatorDkkAmountComp {...calculatorData} onOpenModal={this.handleOpenModal} />}
        <BaseModal isOpen={isModalOpen}>
          <div
            onClick={this.handleCloseModal}
            className={cx(styles.modal, isModalOpen && styles.open)}
          >
            <InfoBox {...activeHelpText} onCloseModal={this.handleCloseModal} />
          </div>
        </BaseModal>
      </div>
    )
  }
}

export default CalculatorDkkAmount